import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingNavbar from './common/LandingNavbar';
import './LandingPage.css';
import './BlogPage.css';

const POSTS = [
  { id: 'spacedRepetition', date: '2025-01-15', category: 'learningTips', image: '📚' },
  { id: 'cefr', date: '2025-01-10', category: 'education', image: '🎓' },
  { id: 'ielts', date: '2025-01-05', category: 'examPrep', image: '📝' },
  { id: 'levels', date: '2024-12-28', category: 'learningTips', image: '📖' },
  { id: 'ai', date: '2024-12-20', category: 'technology', image: '🤖' }
];

const dateLocale = (language) => {
  if (language?.startsWith('ar')) return 'ar';
  if (language?.startsWith('fr')) return 'fr';
  return 'en';
};

const BlogPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('landing');

  const formatDate = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString(dateLocale(i18n.language), {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="blog-page">
      <LandingNavbar />

      <section className="blog-hero">
        <div className="blog-hero-content">
          <h1>{t('blogPage.title')}</h1>
          <p>{t('blogPage.subtitle')}</p>
        </div>
      </section>

      <section className="blog-section">
        <div className="section-container">
          <div className="blog-grid">
            {POSTS.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <span className="blog-emoji">{post.image}</span>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-category">{t(`blogPage.categories.${post.category}`)}</span>
                    <span className="blog-date">{formatDate(post.date)}</span>
                  </div>
                  <h2 className="blog-title">{t(`blogPage.posts.${post.id}.title`)}</h2>
                  <p className="blog-excerpt">{t(`blogPage.posts.${post.id}.excerpt`)}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-container">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="material-icons">school</span>
              <span>Syllera</span>
            </div>
            <p className="footer-description">
              {t('footer.tagline')}
            </p>
          </div>
          <div className="footer-section">
            <h4>{t('footer.product')}</h4>
            <ul>
              <li><a href="/#features" onClick={(e) => { e.preventDefault(); navigate('/#features'); }}>{t('nav.features')}</a></li>
              <li><a href="/#pricing" onClick={(e) => { e.preventDefault(); navigate('/#pricing'); }}>{t('nav.pricing')}</a></li>
              <li><a href="/#how-it-works" onClick={(e) => { e.preventDefault(); navigate('/#how-it-works'); }}>{t('nav.howItWorks')}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.company')}</h4>
            <ul>
              <li><a href="/about">{t('footer.about')}</a></li>
              <li><a href="/contact">{t('footer.contact')}</a></li>
              <li><a href="/blog">{t('footer.blog')}</a></li>
              <li><a href="/partners">{t('footer.becomeAPartner')}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.support')}</h4>
            <ul>
              <li><a href="/#faq" onClick={(e) => { e.preventDefault(); navigate('/#faq'); }}>{t('footer.faq')}</a></li>
              <li><a href="/help-center">{t('footer.helpCenter')}</a></li>
              <li><a href="/contact-support">{t('footer.contactSupport')}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <div className="footer-links">
            <a href="/privacy-policy">{t('footer.privacyPolicy')}</a>
            <a href="/terms-of-service">{t('footer.termsOfService')}</a>
            <a href="/cookie-policy">{t('footer.cookiePolicy')}</a>
            <a href="/refund-policy">{t('footer.refundPolicy')}</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;
